import type { SgBsTheme } from 'state/userPreferences/userPreferences.model';

export function getDefaultTheme(): SgBsTheme {
  const defaultTheme = (import.meta as ImportMeta)?.env?.VITE_SGBS_THEME;
  switch (defaultTheme) {
    case 'dark':
      return 'dark';
    case 'standard':
      return 'light';
    default:
      return 'light';
  }
}
